export default __webpack_public_path__ + "static/media/Nav_man_2056.bdd74127.png";